import { Feature } from "@formant/core/model/Feature";
import { OrganizationFeatureFlag } from "@formant/core/model/OrganizationFeatureFlag";
import { ResourcePolicy } from "@formant/core/model/Policies";
import { Resource } from "@formant/core/model/Resource";

import { authStore, organizationStore } from "../../stores";

export interface IRestrictedListParameters<T, R extends Resource = Resource> {
    items: T[];
    resource: Resource;
    requiredAccess?: ResourcePolicy<R>;
    requiredFeature?: Feature;
    // convience parameter that allows additional checks
    // to be true otherwise returns an empty list
    disabled?: boolean;
    paidOnly?: boolean;
    featureFlag?: OrganizationFeatureFlag;
}

export class RestrictedList<T> {
    public new(input: IRestrictedListParameters<T>): T[] {
        const {
            disabled,
            items,
            resource,
            requiredAccess,
            requiredFeature,
            featureFlag,
        } = input;

        if (disabled) {
            return [];
        }

        if (
            featureFlag &&
            !organizationStore.getFeatureFlags().has(featureFlag)
        ) {
            return [];
        }

        return authStore.hasAccess(resource, requiredAccess, requiredFeature)
            ? items
            : [];
    }
}
